import { useMapWorkAreasFlag } from 'modules/locations/hooks/useMapWorkAreasFlag'
import { useWorkAreaMaps } from 'modules/space_control/hooks/useWorkAreaMaps'

interface UseWorkAreaMapAvailabilityProps {
  workAreaId: number
}

export const useWorkAreaMapAvailability = ({ workAreaId }: UseWorkAreaMapAvailabilityProps) => {
  const hasMapWorkAreasFlag = useMapWorkAreasFlag()

  const { workAreaMapsById, loading } = useWorkAreaMaps({
    workAreaIds: [workAreaId],
    skip: !hasMapWorkAreasFlag,
  })

  const workAreaMap = workAreaMapsById[workAreaId]

  return {
    loading,
    workAreaMap,
    hasMapWorkAreasFlag,
  }
}
